import { Actions } from 'Constants'

export const clearAppError = () => ({
    type: Actions.APP_ERROR
})
